var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVertSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1352.53 793.7",
    style: {
      enableBackground: "new 0 0 1352.53 793.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DFD41B;}\r\n\t.st1{font-family:'MADETommySoft-Light';}\r\n\t.st2{font-size:127.0276px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 506.7,
    cy: 146.81,
    rx: 24.63,
    ry: 25.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 578.55,
    cy: 146.81,
    rx: 24.63,
    ry: 25.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "85.78,113.88 179.28,113.88 256.47,396.14 336.79,113.88 411.16,113.88 295.38,510.34  199.68,510.34  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.8,383.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "506.54,450.8 646.17,450.8 646.17,510.34 436.89,510.34 436.89,206.99 646.17,206.99  646.17,262.47 506.7,262.47 506.7,327.03 616.99,327.03 616.99,383.16 506.54,383.16 506.54,450.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M922.5,510.55h-75.31l-46.02-120.69h-50.2v120.69H681.1V206.99h150.61c96.63,0,118.81,134.42,37.23,169.03 L922.5,510.55z M751.39,260.52v77.86h67.36c41-16.01,34.72-71.81,0-77.86H751.39z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "943.84,206.99 943.84,266.58 1016.21,266.58 1016.21,510.55 1087.75,510.55 1087.75,266.58  1159.29,266.58 1159.29,206.99  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1266.76,139.19c0,18.96-14.87,34.33-33.21,34.33c-18.34,0-33.21-15.37-33.21-34.33s14.87-34.33,33.21-34.33 C1251.89,104.85,1266.76,120.22,1266.76,139.19z M1233.95,112.18c-14.39,0-26.06,12.06-26.06,26.94 c0,14.88,11.67,26.94,26.06,26.94s26.06-12.06,26.06-26.94C1260,124.25,1248.34,112.18,1233.95,112.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1220.99,156.84v-34.99h14.38c3.62,0,6.24,0.31,7.88,0.94c1.64,0.63,2.95,1.75,3.94,3.35 c0.98,1.61,1.48,3.45,1.48,5.51c0,2.63-0.75,4.79-2.24,6.5c-1.49,1.71-3.72,2.79-6.69,3.23c1.48,0.89,2.7,1.87,3.66,2.94 c0.96,1.07,2.26,2.96,3.89,5.68l4.13,6.83h-8.17l-4.94-7.61c-1.75-2.72-2.95-4.44-3.6-5.14c-0.65-0.71-1.33-1.19-2.05-1.46 c-0.72-0.26-1.87-0.39-3.44-0.39h-1.39v14.61H1220.99z M1227.83,136.65h5.06c3.28,0,5.32-0.14,6.14-0.43 c0.82-0.29,1.45-0.78,1.92-1.48c0.46-0.7,0.69-1.58,0.69-2.63c0-1.18-0.3-2.13-0.91-2.85c-0.61-0.72-1.47-1.18-2.57-1.37 c-0.55-0.08-2.22-0.12-4.99-0.12h-5.33V136.65z"
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9671 0 0 1 90.51 658.81)",
    className: "st0 st1 st2"
  }, "ILUMINA TU ESPACIO"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertSvg);
export default __webpack_public_path__ + "static/media/VERT-SVG.59f454cdb75eff2f4c76d4f3c745c27e.svg";
export { ForwardRef as ReactComponent };